import React from 'react'
import PropTypes from 'prop-types';

const RegionCardBody = ({
  className = "",
  classNames = "",
  children,
  style = {},
  /**
   * Cards usually have headers, but not footers.
   */
  hasHeader = true,
  hasFooter = false,
  ...rest
}) => {
  return (
    <div className={`card-body ${classNames} ${className} ${!hasHeader && "card-headerless"} ${!hasFooter && "card-footerless"} ${(!hasHeader && !hasFooter) && "card-only-child"}`} style={{...style}} {...rest}>
      {children}
    </div>
  );
}

RegionCardBody.propTypes = {
   /**
   * Adds styles handle headerless cards
   */
  hasHeader: PropTypes.bool,
  /**
   * Adds styles handle footerless cards
   */
  hasFooter: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  /**
   * @deprecated Use className instead
   */
  classNames: PropTypes.string,
  children: PropTypes.element
}

export default RegionCardBody;